
import { propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Watch } from "vue-property-decorator";

interface ParcelPlaceholderProps {
  placeholderUrl?: string;
}

const Props = propsInstance<ParcelPlaceholderProps>({
  placeholderUrl: {
    type: String,
    required: false,
    default: "",
  },
});

@Component<ParcelPlaceholder>({
  name: "ParcelPlaceholder",
})
export default class ParcelPlaceholder extends mixins(MixedVue, Props) {
  $emit: {
    (e: "load");
  };

  mounted() {
    this.getImage();
  }

  @Watch("placeholderUrl")
  async getImage() {
    if (!this.placeholderUrl) {
      this.$el.textContent = "";
      return;
    }
    const placeholder = await this.$store.dispatch("getParcelPlaceholder", this.placeholderUrl);
    if (!placeholder) return;

    const svg = new DOMParser().parseFromString(placeholder, "image/svg+xml").firstChild as HTMLElement;

    this.$el.textContent = "";
    [...svg.attributes].forEach(({ name, value }) => this.$el.setAttribute(name, value));
    this.$el.setAttribute("preserveAspectRatio", "xMidYMid meet");
    this.$el.appendChild(svg.firstChild);
    this.$emit("load");
  }
}
